module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmOTdlM2JiZjczMjU0YjAxMTIwOTFkMDE5MmYxN2FlYy5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ../~/slick-carousel/slick/fonts/slick.svg
// module id = 1428
// module chunks = 0